//
// esbuild can reorder imports and push them at the begininning of the file
// so keep jquery config in a dedicated file
import './bootstrap.js'

import 'bootstrap';

// ----------------- jQuery datepicker
// don't know why, it only works if require is in the same file as
// require('jquery') :-|
import "jquery-ui/ui/widgets/datepicker";

// -------------- Raleway font
import 'typeface-raleway';

// -------------- Masonry (for list of blog posts and publications)
import jQueryBridget from 'jquery-bridget';
import Masonry  from 'masonry-layout';
jQueryBridget( 'masonry', Masonry, $ );

$(document).ready(function(){
    $('.grid').masonry({
      itemSelector: '.grid-item',
      columnWidth: '.grid-sizer',
      percentPosition: true
    });
});

// ----------------- toastr notifications
// https://cylab.be/blog/219/notifications-with-toastr-and-laravel
import toastr from 'toastr';
window.toastr = toastr;

toastr.options = {
    "closeButton": true,
    "closeClass": "toast-close-button",
    "closeDuration": 300,
    "closeEasing": "swing",
    "closeHtml": "<button><i class=\"icon-off\"></i></button>",
    "closeMethod": "fadeOut",
    "closeOnHover": true,
    "containerId": "toast-container",
    "debug": false,
    "escapeHtml": false,
    "extendedTimeOut": 10000,
    "hideDuration": 1000,
    "hideEasing": "linear",
    "hideMethod": "fadeOut",
    "iconClass": "toast-info",
    "iconClasses": {"error": "toast-error", "info": "toast-info", "success": "toast-success", "warning": "toast-warning"},
    "messageClass": "toast-message",
    "newestOnTop": false,
    "onHidden": null,
    "onShown": null,
    "positionClass": "toast-top-right",
    "preventDuplicates": true,
    "progressBar": true,
    "progressClass": "toast-progress",
    "rtl": false,
    "showDuration": 300,
    "showEasing": "swing",
    "showMethod": "fadeIn",
    "tapToDismiss": true,
    "target": "body",
    "timeOut": 5000,
    "titleClass": "toast-title",
    "toastClass": "toast"
};

// ------------ Highlight current link in main menu
$(document).ready(function() {
    let current = location.pathname;
    $('.highlight-active a').each(function(){
        let link = $(this);
        let parser = document.createElement('a');
        parser.href = link.attr('href');
        let link_path = parser.pathname;

        if (current === "/") {
            // we are at the homepage...
            if (link_path === "/") {
                link.addClass('active');
                return;
            }

        } else {
            if (link_path === "/") {
                return;
            }

            if(current.indexOf(link_path) === 0){
                link.addClass('active');
            }
        }
    });
});

// ------------- Syntax highlighting (for example on projects)
// the list of supported languages is in esbuild.mjs, in getJsConfig > plugins
import Prism from 'prismjs';
$(document).ready(function(){
    Prism.highlightAll();
});


// ---------------- Single click select
$(".single-click").click(function() {
    $(this).focus();
    $(this).select();
});

// ----------------- lightbox
import 'lightbox2';

// ----------------- same-height
// set the size of blocks that have the class="same-height"
function sameHeight() {
    // allow browser to resize each block individually
    $('.same-height').height('auto');

    // search height of largest block
    let max_height = 0;
    $('.same-height').each(function(i, el) {
        if ($(el).height() > max_height) {
            max_height = $(el).height();
        }
    });

    // set size of all blocks
    $('.same-height').height(max_height);
}

document.addEventListener("DOMContentLoaded", sameHeight);
window.addEventListener('resize', sameHeight);

// ----------------- shareon.js
import * as Shareon from "shareon";
Shareon.init();


// ----------------- filter table
import Mark from "mark.js";
let mark = new Mark("#filter-table");
$("#filter-input").on("keyup", function() {
    let value = $(this).val().toLowerCase();
    mark.unmark();
    mark.mark(value);

    $("#filter-table tr").filter(function() {
        $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1);
    });
});

// ------------------ chart.js
import 'chart.js/dist/Chart.bundle.js';

window.chartColors = {
	red: 'rgb(255, 99, 132)',
	orange: 'rgb(255, 159, 64)',
	yellow: 'rgb(255, 205, 86)',
	green: 'rgb(75, 192, 192)',
	blue: 'rgb(54, 162, 235)',
	purple: 'rgb(153, 102, 255)',
	grey: 'rgb(201, 203, 207)'
};

// used on the actors pages
import L from 'leaflet/dist/leaflet.js';


